import React from 'react';
import _ from 'underscore';
import events from './manifest';
import { Radio } from 'react-bootstrap';
import EventsListQuery from './events-query/EventsListQuery';
import Loader from '../../../common/components/notifications/Loader';
import Buttons from './components/Buttons';
import Lists from './components/Lists';
import { toShortID } from '../../../utils/parse-event-id';
import prop from 'ramda/src/prop';
import path from 'ramda/src/path';

function Push (_push) {
    return function push (Ev) {
        return function (data) {
            _push(Ev(data));
        };
    };
}

function TargetTab (props) {
    var push = Push(props.push);

    function handleChange (ev) {
        var typeID = ev.target.value;
        props.push(events.changeScope(Number(typeID)));
    }

    var handleCatAssign = _.compose(
        push(events.assignCategory),
        prop('categoryID')
    );

    var handleCatUnassign = _.compose(
        push(events.unassignCategory),
        prop('categoryID')
    );

    var handleEventUnassign = _.compose(
        push(events.unassignCampaignEvent),
        toShortID,
        prop('eventID')
    );

    var handleEventAssign = _.compose(
        push(events.assignCampaignEvent),
        toShortID,
        prop('eventID')
    );

    var scope = props.pendingEdits.typeID || props.vast.data.typeID;
    var isResolving = props.events.resolving.length > 0;

    var assignedCats = props.pendingEdits.campaignCategoryIDs ||
        props.vast.data.campaignCategoryIDs ||
        []
    ;

    var assignedEvents = (props.pendingEdits.campaignEvents ||
        props.vast.data.campaignEvents ||
        [])
        .map(function (ev) {
            if (typeof ev === 'string') {
                var _ev = _(props.vast.data.campaignEvents)
                    .find(function (e) {
                        return toShortID(e.eventID) === toShortID(ev);
                    })
                ;
                if (_ev) return _ev;
                _ev = _(props.events.data).findWhere({
                    eventID: toShortID(ev)
                });
                return _ev;
            }
            return ev;
        })
    ;

    var availableEvents = (props.events.data || []).filter(function (ev) {
        var _ev = _(assignedEvents).find(function (assigned) {
            return toShortID(assigned.eventID) === ev.eventID;
        });
        return !_ev;
    });

    var globalCampaignExists = _(props.vastList.data).findWhere({
        typeID: 1
    });

    var isNewCampaign = !path(['vast', 'data', 'campaignID'], props);

    return <div className="target-tab-content vast-tab-content clearfix">
        <div className="">
            <div className="col-sm-12">
                <hr/>
            </div>

            <div className="col-sm-12">

                <div className="form-group">
                    <label htmlFor="">Campaign scope</label>
                    <div className="clearfix">
                        {['All events', 'By category', 'By event']
                            .map(function (text, i) {
                                // disable global radio if a global campaign
                                // already exists
                                var disabled = props.disabled ||
                                    (globalCampaignExists && isNewCampaign &&
                                        i === 0)
                                ;

                                return <div
                                    key={i}
                                    className="col-sm-4"
                                >
                                    <Radio
                                        disabled={disabled}
                                        onChange={handleChange}
                                        name="campaign-scope"
                                        value={i + 1}
                                        checked={scope == i + 1}
                                        inline
                                    >
                                        {text}
                                    </Radio>
                                </div>;
                            })
                        }

                        <span className="help-block col-sm-12"
                            style={{ marginTop: '1em' }}
                        >
                            <span className="glyphicon glyphicon-info-sign"
                                aria-hidden="true"></span> Only 1 campaign can target 'All events'
                        </span>

                        <div className="col-sm-12">
                            <hr />
                        </div>
                    </div>

                    {scope == 3 ? [
                        (<div style={{ backgroundColor: 'white' }} key={0}>
                            <p className="help-block">
                                Search for events
                            </p>
                            <EventsListQuery
                                key={1}
                                {...props.eventsQuery}
                                disabled={isResolving || props.disabled}
                                onSearchParamChange={
                                    push(events.eventsQuery.changeSearchKey)}
                                onChange={push(events.eventsQuery.change)}
                                onSubmit={push(events.submitQuery)}
                            />
                        </div>),
                        (<div key={2} className="col-sm-12">
                            <hr />
                        </div>)] :

                        null
                    }

                    {scope == 1 ?  // global scope
                        null :
                        scope == 2 ?
                            (<CategoryList
                                {...props.categories}
                                assigned={assignedCats}
                                onAssign={handleCatAssign}
                                onUnassign={handleCatUnassign}
                            />) :
                            (<EventsList
                                {...props.events}
                                disabled={props.disabled}
                                assigned={assignedEvents}
                                available={availableEvents}
                                onAssign={handleEventAssign}
                                onUnassign={handleEventUnassign}
                            />)
                    }
                </div>


            </div>
        </div>

    </div>;
}

function EventsList (props) {
    return <div className="clearfix">
        <div className="col-sm-6">
            <h4>Assigned events</h4>

            <ul className="list-unstyled vast-assign-list well">
                {props.assigned.map(function (ev, i) {
                    return <Lists.ListItem key={i} title={ev.title}>
                        <Buttons.Remove
                            disabled={props.disabled}
                            onClick={props.onUnassign.bind(null, ev)}
                        />
                    </Lists.ListItem>;
                })}
            </ul>

        </div>

        <div className="col-sm-6">
            <h4>Available events</h4>
            <ul className="list-unstyled vast-assign-list well">

                {props.available.map(function (ev, i) {
                    return <Lists.ListItem key={i}
                        title={ev.title}
                    >
                        <Buttons.Assign
                            disabled={props.disabled}
                            onClick={() => props.onAssign(ev)}
                        />
                    </Lists.ListItem>;
                })}
            </ul>
        </div>
    </div>;
}

// EventsList.propTypes = {
//     onAssign: pt.func.isRequired,
//     onUnassign: pt.func.isRequired
// };

EventsList.defaultProps = {
    assigned: [],
    available: []
};

function CategoryList (props) {
    if (props.resolving.length) {
        return <Loader message="Fetching" />;
    }

    function handleAssign (cat, ev) {
        props.onAssign(cat);
    }

    function handleRemove (cat, ev) {
        props.onUnassign(cat);
    }

    var available = _.chain(props.data)
        .toArray()
        .filter(function (cat) {
            return props.assigned.indexOf(cat.categoryID) === -1;
        })
        .sortBy('categoryName')
        .value()
    ;

    return <div className="category-list clearfix">

        <div className="col-sm-6">
            <h4>Assigned categories</h4>
            <ul className="list-unstyled vast-assign-list well">
                {props.assigned.map(function (catID, i) {
                    var cat = props.data[catID];
                    return <Lists.ListItem key={i}
                        title={cat.categoryName}
                        className="category"
                    >
                        <Buttons.Remove
                            disabled={props.disabled}
                            onClick={handleRemove.bind(null, cat)}
                        />
                    </Lists.ListItem>;
                })}
            </ul>
        </div>

        <div className="col-sm-6">
            <h4>Available categories</h4>
            <ul className="list-unstyled vast-assign-list well">
                {available.map(function (cat, i) {
                    return <Lists.ListItem key={i}
                        title={cat.categoryName}
                        className="category"
                    >
                        <Buttons.Assign
                            disabled={props.disabled}
                            onClick={handleAssign.bind(null, cat)}
                        />
                    </Lists.ListItem>;
                })}
            </ul>
        </div>
    </div>;
}


export default TargetTab;
